/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://discussion-tool-demo-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://discussion-tool-demo.geodemosolutions.com/#/'
  baseApiUrl = 'https://clara-discussion-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://clara-discussion-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/clara-discussion-tool-api/public/'
  appBaseUrl = 'http://localhost:4000/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
